module.exports = __webpack_public_path__ + "media/Selamat_Pengantin_Baru-Saloma.ed423abd.mp3";